export const MARKETING_BRIEFING = {
  greeting: {
    date: 'Monday, Jan 27',
    meetings: 2,
    tasks: 4,
    campaignAlerts: 1,
    lucMessage: "Hey Priya, good start to the week! Marsi flagged that the PLG content series is gaining traction — blog traffic up 14% from last week. A couple of things need your eye today."
  },
  campaigns: [
    {
      id: 'c1',
      title: 'Meta Brand Awareness Push',
      agent: 'marsi',
      status: 'live',
      alert: true,
      metrics: [
        { label: 'Impressions', value: '28,400' },
        { label: 'CTR', value: '1.9%', alert: true, target: '2.8%' },
        { label: 'Spend', value: '$2,100 / $5,000' },
        { label: 'Leads', value: '12' },
      ],
      description: 'CTR is below the 2.8% target. Marsi recommends narrowing audience targeting to VP+ titles.',
      expanded: {
        summary: 'Campaign launched 5 days ago. Impressions are healthy but click-through is underperforming. The broad audience targeting is attracting non-decision-makers.',
        details: [
          { label: 'Launch Date', value: '5 days ago' },
          { label: 'Target Audience', value: 'SMB founders, Dev Tools, US/EU' },
          { label: 'Current CTR', value: '1.9% (target: 2.8%)' },
          { label: 'Daily Spend', value: '$420/day' },
          { label: 'Projected Leads', value: '25 (target: 35-50)' },
        ],
        thinking: 'Marsi analyzed the first 5 days of campaign data. The "broad SMB" audience segment is generating impressions but low engagement. VP+ titles and founder personas convert at 3.4x the rate of general SMB targeting. Recommends narrowing and pausing the underperforming ad set.',
        proposedActions: [
          { label: 'Narrow targeting to VP+ titles', agent: 'Marsi' },
          { label: 'Pause underperforming ad set B', agent: 'Marsi' },
          { label: 'Reallocate $800 to top-performing creative', agent: 'Marsi' },
        ]
      }
    },
    {
      id: 'c2',
      title: 'LinkedIn Developer Series',
      agent: 'marsi',
      status: 'ready',
      alert: false,
      description: 'Campaign ready for launch. Targeting VP+ at dev tool companies. Budget: $3,200.',
      expanded: {
        summary: 'Marsi has built a 4-week LinkedIn sponsored content series targeting developer tool decision-makers. All creatives reviewed by Wright for copy consistency.',
        details: [
          { label: 'Budget', value: '$3,200 (4 weeks)' },
          { label: 'Target', value: 'VP+ at Dev Tool companies, US/EU' },
          { label: 'Content', value: '8 sponsored posts + 2 lead gen forms' },
          { label: 'Projected Reach', value: '62,000 impressions' },
          { label: 'Expected Leads', value: '40-55 MQLs' },
        ],
        artifacts: [
          { name: 'Campaign Brief', type: 'pdf' },
          { name: 'Creative Mockups', type: 'image' },
          { name: 'Targeting Config', type: 'pdf' },
        ],
        thinking: 'Marsi designed this campaign based on the Q1 GTM strategy approved by Arjun. The developer series focuses on use-case content rather than product features, which historically performs 2.1x better on LinkedIn for our audience.'
      }
    }
  ],
  tasks: {
    today: [
      {
        id: 't1',
        title: 'Review blog post: "AI Ops for SMBs"',
        agent: 'wright',
        urgency: 'due-today',
        description: 'Wright has finished the draft. 1,800 words. Needs your review before publishing at 2 PM.',
        expanded: {
          summary: 'Wright wrote this piece based on Dora\'s research on SMB pain points. It targets the "awareness" stage of the funnel.',
          artifacts: [
            { name: 'Blog Draft', type: 'pdf' },
            { name: 'SEO Analysis', type: 'spreadsheet' },
          ],
          thinking: 'Wright optimized the draft for 3 target keywords identified by Dora. Expected organic traffic: 200-300 visits/month after 30 days. The piece ties into the LinkedIn Developer Series campaign for content synergy.'
        }
      },
      {
        id: 't2',
        title: 'Approve social content calendar',
        agent: 'buzz',
        urgency: 'due-today',
        description: 'Buzz has prepared next week\'s social calendar. 8 posts across LinkedIn and Twitter.',
        expanded: {
          summary: 'The calendar includes 5 LinkedIn posts (2 carousels, 3 text) and 3 Twitter threads. All copy reviewed by Wright.',
          details: [
            { label: 'LinkedIn Posts', value: '5 (2 carousels, 3 text)' },
            { label: 'Twitter Threads', value: '3' },
            { label: 'Estimated Reach', value: '12,000 impressions' },
            { label: 'Best Posting Times', value: 'Tue 9AM, Thu 11AM' },
          ],
          artifacts: [
            { name: 'Content Calendar', type: 'spreadsheet' },
            { name: 'Carousel Designs', type: 'image' },
          ]
        }
      },
      {
        id: 't3',
        title: 'Review ad creative variations',
        agent: 'marsi',
        description: 'Marsi generated 3 ad creative options for the LinkedIn campaign. Pick the final variant.',
        expanded: {
          summary: '3 creative directions for the LinkedIn Developer Series. Marsi recommends Variant B based on historical engagement data.',
          artifacts: [
            { name: 'Variant A - Minimal', type: 'image' },
            { name: 'Variant B - Data-led', type: 'image' },
            { name: 'Variant C - Testimonial', type: 'image' },
          ],
          thinking: 'Marsi tested similar creative styles in the last 3 campaigns. Data-led creatives (Variant B) consistently outperform minimal and testimonial styles by 1.8x on CTR for the developer audience.'
        }
      },
      {
        id: 't4',
        title: 'Check Meta campaign metrics',
        agent: 'marsi',
        urgency: 'due-today',
        description: 'Marsi has the 12 PM metrics snapshot ready. Expect sign-off on pause + reallocation before Raj\'s 2 PM deadline.',
        expanded: {
          summary: '5-day Meta Brand Awareness performance check. CTR below target; Ad Set B dragging the blended rate. Marsi will walk you through pause + reallocation plan.',
          details: [
            { label: 'CTR', value: '1.9% (target 2.8%)' },
            { label: 'Spend', value: '$2,100 of $5,000' },
            { label: 'Projected Leads', value: '17 (target 25)' },
            { label: 'Raj deadline', value: '2:00 PM' },
          ],
        }
      }
    ],
    ifTime: [
      { id: 'td1', title: 'Competitor content audit', agent: 'dora', description: 'Dora compiled a competitor content analysis. Low priority but useful for Q2 planning.' },
      { id: 'td2', title: 'Newsletter draft review', agent: 'wright', description: 'Monthly newsletter draft from Wright. Send date is Friday — not urgent yet.' }
    ]
  },
  leadMetrics: {
    snapshot: [
      { label: 'MQLs this week', value: '47', trend: '+12%' },
      { label: 'MQL to SQL rate', value: '18%', trend: '-6%', alert: true },
      { label: 'Top channel', value: 'LinkedIn Organic' },
      { label: 'Blog traffic', value: '4,200 visits', trend: '+14%' },
      { label: 'Cost per lead', value: '$118', trend: '-8%' },
    ],
    alert: {
      id: 'la1',
      title: 'Lead quality dropped 18% this week',
      agents: ['marsi', 'dora'],
      severity: 'high',
      description: 'New content campaign attracting wrong persona. MQL to SQL conversion down from 24% to 18%.',
      expanded: {
        details: [
          { label: 'Lead Quality Score', value: 'Down 18% (7-day trend)' },
          { label: 'MQL to SQL Conversion', value: '18% (was 24%)' },
          { label: 'Root Cause', value: '"AI for Everyone" blog series attracting individual users' },
          { label: 'Pipeline Impact', value: '$45K in projected pipeline at risk' },
          { label: 'Affected Channels', value: 'LinkedIn Ads, Blog organic' },
        ],
        thinking: 'Marsi and Dora cross-referenced campaign attribution with lead scoring. The "AI for Everyone" blog series ranks well but attracts individual users, not SMB decision-makers. Recommends narrowing content targeting and adjusting ad copy.',
        proposedActions: [
          { label: 'Narrow LinkedIn ad targeting to VP+ titles', agent: 'Marsi' },
          { label: 'Adjust blog content tone to SMB use cases', agent: 'Wright' },
          { label: 'Re-score existing MQLs with updated criteria', agent: 'Dora' },
        ]
      }
    }
  },
  meetings: [
    { id: 'mm1', title: 'Content sync', time: '10:30 AM', duration: '30 min', with: 'Neha & Rohan', type: 'internal', agenda: ['Blog post review status', 'Social calendar for next week', 'LinkedIn campaign creative selection'] },
    { id: 'mm2', title: 'Campaign review with Arjun', time: '2:00 PM', duration: '45 min', with: 'Arjun Mehta (CEO)', type: 'internal', agenda: ['Q1 GTM strategy update', 'Meta campaign performance review', 'Budget reallocation discussion'] },
  ],
  needsDecision: [
    {
      id: 'pnd1',
      agent: 'marsi',
      title: 'Narrow Meta targeting to VP+ (reallocate $800)',
      description: 'Meta Ad Set A is bleeding CTR on generic SMB audience. Marsi recommends narrowing to VP+ only and reallocating $800 to the LinkedIn top performer.',
      amountLabel: 'Budget shift',
      amount: '$800',
      urgency: 'normal',
      expanded: {
        summary: "Ad Set A is our lowest-performing active audience at 2.1% CTR. Narrowing to VP+ cuts reach but should lift CTR to 3%+. 48-hour checkpoint: if CTR doesn't move, we pause A entirely and move fully to LinkedIn.",
        details: [
          { label: 'Current CTR (Ad Set A)', value: '2.1% (target 2.8%)' },
          { label: 'VP+ historical CTR', value: '3.0%+' },
          { label: 'Reallocation target', value: 'LinkedIn top performer (3.4% CTR)' },
          { label: 'Checkpoint', value: '48 hours' },
        ],
      },
    },
    {
      id: 'pnd2',
      agent: 'marsi',
      title: 'Pause PLG Content Series ad set B',
      description: 'Ad Set B at 1.1% CTR — dragging blended performance. Marsi recommends immediate pause, no reallocation (let the budget roll to LinkedIn weekly cap).',
      amountLabel: 'Monthly spend freed',
      amount: '$420',
      urgency: 'normal',
      expanded: {
        summary: 'Ad Set B was the broad-reach experiment. It failed cleanly — good learning, time to stop the bleed. No need to reallocate immediately; LinkedIn has room at current pacing.',
        details: [
          { label: 'Ad Set B CTR', value: '1.1% (bottom decile)' },
          { label: 'Audience', value: '"SMB + tech-curious" (too broad)' },
          { label: 'Decision needed', value: 'Pause confirmed?' },
        ],
      },
    },
    {
      id: 'pnd3',
      agent: 'marsi',
      title: 'Approve LinkedIn Developer Series launch ($3,200)',
      description: 'Campaign ready — creative approved, targeting tight (VP+ at dev tools, 50-200 employees), Thursday 9 AM launch. Needs final budget sign-off.',
      amountLabel: 'Campaign budget',
      amount: '$3,200',
      urgency: 'normal',
      expanded: {
        summary: '4-week sponsored content campaign on LinkedIn. Projected 62K impressions, 40-55 MQLs. Weekly pacing flex enabled ($600-$1000) based on week-1 CTR performance.',
        details: [
          { label: 'Duration', value: '4 weeks' },
          { label: 'Launch', value: 'Thursday 9 AM' },
          { label: 'Weekly pacing', value: '$600-$1,000 (flex)' },
          { label: 'Projected MQLs', value: '40-55' },
          { label: 'Auto-pause rule', value: 'Variant D cutoff at 72h if CTR <2.5%' },
        ],
      },
    },
  ],
  dailyTimeline: [
    { time: '9:00 AM', type: 'task', title: 'Review blog post: "AI Ops for SMBs"', agent: 'wright' },
    { time: '9:30 AM', type: 'task', title: 'Approve social content calendar', agent: 'buzz' },
    { time: '10:00 AM', type: 'task', title: 'Review ad creative variations', agent: 'marsi' },
    { time: '10:30 AM', type: 'meeting', title: 'Content sync', duration: '30 min', with: 'Neha & Rohan' },
    { time: '12:00 PM', type: 'task', title: 'Check Meta campaign metrics', agent: 'marsi' },
    { time: '2:00 PM', type: 'meeting', title: 'Campaign review with Arjun', duration: '45 min', with: 'Arjun Mehta (CEO)' },
  ],
  inbox: [
    { id: 'mki1', sender: 'Neha Gupta (Design)', senderInitials: 'NG', time: '8:30 AM', summary: 'LinkedIn carousel assets ready for review — 6 slides attached.', expandedSummary: 'Neha completed the LinkedIn Developer Series carousel. 6 slides covering the product deep-dive, all following brand guidelines. She\'s asking for copy feedback on slides 3 and 5 before the scheduled Thursday launch. Files are in the shared Drive folder.' },
    { id: 'mki2', sender: 'Raj Bhandari (Agency)', senderInitials: 'RB', time: '8:05 AM', summary: 'Meta campaign optimization report — recommending pause on Ad Set B.', expandedSummary: 'Raj from the agency sent the 5-day performance report. Ad Set B is underperforming at 1.1% CTR vs 2.8% target. He recommends pausing it and reallocating the $800 budget to the top-performing LinkedIn creative (3.4% CTR). Needs your approval to execute the shift today.' },
    { id: 'mki3', sender: 'Arjun Mehta (CEO)', senderInitials: 'AM', time: '7:50 AM', summary: 'Wants a quick sync on the product launch content calendar before his 2pm meeting.', expandedSummary: 'Arjun wants to review the content calendar for the upcoming product launch before his investor meeting at 2 PM. Specifically interested in the blog cadence, social distribution plan, and whether the developer community activation is on track. Asking if you can send a summary doc by noon.' },
    { id: 'mki4', sender: 'David Chen (Sales)', senderInitials: 'DC', time: 'Yesterday', summary: 'Requesting case study for TechCorp re-engagement — needs it by Wednesday.', expandedSummary: 'David needs a customer case study for TechCorp re-engagement outreach. Looking for a similar company profile (enterprise, API-heavy integration) with clear ROI metrics. Sally has identified the story but needs marketing to package it. Wednesday EOD deadline to align with the outreach sequence.' },
    { id: 'mki5', sender: 'Wright (Brand Agent)', senderInitials: 'W', time: 'Yesterday', summary: 'Blog post SEO analysis complete — 3 keyword opportunities flagged.', expandedSummary: 'Wright ran SEO analysis on the draft blog post. Found 3 high-volume, low-competition keywords that should be woven into the H2 headers and meta description. Also flagged that the current title has low click-through potential and suggested 2 alternatives. Full report attached with implementation notes.' },
  ]
};
